import { call, takeLatest } from "redux-saga/effects";
import apiRequest from "utils/api";
import { getEnvConfig } from "helpers/environment-config";
import { buildLoginPath } from "helpers/auth-redirect";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";

const initialState = {};

// Reducer
export default function changePasswordReducer(state = initialState, { type, payload }) {
  switch (type) {
    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state
      };
    default:
      return state;
  }
}

// Action
export function changePasswordRequest(payload) {
  return {
    type: CHANGE_PASSWORD_REQUEST,
    payload
  };
}

// Saga
const changePasswordRequestSaga = function* (action) {
  const { payload: reqPayload } = action;
  yield call(apiRequest, "/changePassword", "POST", reqPayload);

  const authUIUrl = yield call(getEnvConfig, "authUIUrl");
  const redirectUrl = `${authUIUrl}${buildLoginPath()}`;
  window.location.assign(redirectUrl);
};

export function* changePasswordSaga() {
  yield takeLatest(CHANGE_PASSWORD_REQUEST, changePasswordRequestSaga);
}
